import { LogOut } from "lucide-react";
import { MainNav } from "./main-nav";
import useAuth from "@/contexts/auth/auth-context";

export default function SiteHeader() {
  const { user, logout } = useAuth();

  return (
    <header
      className="flex items-center bg-musio-bg justify-center sticky top-0 z-40 w-full border-b"
      style={{ borderColor: "#2a2a3a" }}
    >
      <div className="w-full flex h-16 items-center justify-between px-6 md:px-8">
        <MainNav />
        <div className="flex items-center gap-4">
          {user &&
            <>
              <p className="text-sm font-medium">{user?.contactName}</p>
              <LogOut className="h-5 w-5 hover:cursor-pointer" onClick={logout} />
            </>
          }
        </div>
      </div>
    </header>
  );
}
